import React from 'react';

import { canUseVisualViewport } from '@eika/hooks';

import useTranslation from '../../../hooks/useTranslation';
import { isIOS } from '../../../utils/native/platform';
import { StickyFooterRow } from '../StickyFooter';

import './DismissKeyboardStickyFooter.scss';

/**
 * The button does nothing, but it is enough to steal the focus away from the input field that caused the keyboard to open
 */
const DismissKeyboardStickyFooter: React.FC = () => {
    const translated = useTranslation();

    if (!isIOS() || !canUseVisualViewport) {
        return <></>;
    }

    return (
        <StickyFooterRow className="dismiss-keyboard-sticky-footer__container" onlyShowWithKeyboard>
            <button type="button" className="dismiss-keyboard-sticky-footer__link">
                {translated.dismissKeyboard}
            </button>
        </StickyFooterRow>
    );
};

export default DismissKeyboardStickyFooter;
